import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, output } from '@angular/core';

/**
 * Emits once when the host element enters the viewport (used to lazy load thumbnails)
 */
@Directive({ selector: '[iuInViewport]', standalone: true })
export class InViewportDirective implements AfterViewInit, OnDestroy {
  readonly inViewport = output<void>();

  readonly #el = inject(ElementRef);
  #observer: IntersectionObserver | undefined;

  ngAfterViewInit() {
    if (typeof IntersectionObserver === 'undefined') {
      // old browsers: load right away, outside the current check
      Promise.resolve().then(() => this.inViewport.emit());
      return;
    }
    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.#disconnect();
          this.inViewport.emit();
        }
      },
      { rootMargin: '100px' }
    );
    this.#observer.observe(this.#el.nativeElement);
  }

  ngOnDestroy() {
    this.#disconnect();
  }

  #disconnect() {
    this.#observer?.disconnect();
    this.#observer = undefined;
  }
}
